export default {
  home: {
    minute: "minuto",
    hour: "ora",
    days: "giorni",
    price_info:
      "I primi {mianfei} minuti sono gratuiti. La tariffa massima per 24 ore è {currencyName}{fengding}. Il tuo deposito {currencyName}{yajin} verrà rimborsato automaticamente dopo la restituzione del power bank",
    feature_1: "Include tutti i tipi di cavi: iPhone, Type‑C",
    feature_2: "Può essere restituito in qualsiasi stazione",
    feature_3: "Ricarica wireless disponibile",
    tips_1:
      "Il tuo deposito {currencyName}{yajin} verrà restituito al termine del noleggio",
    tips_2:
      "Il deposito di ricarica {currencyName}{yajin} può essere usato per il noleggio e, una volta esaurito, può essere rimborsato",
    tips_3:
      "Il saldo attuale è {currencyName}{myyue} e può essere usato direttamente per il noleggio",
    submit: "Inizia noleggio",
    borrow: "Noleggia",
    msg_fail_title: "Errore",
    msg_fail_content: "Noleggio non riuscito, riprova",
    msg_rentcount: "Hai {zujieNum} ordini non chiusi",
    goborrow: "Vai a caricare!!!",
    nearby: "Vedi stazioni vicine",
    preauth: "Pre‑autorizzazione"
  },
  login: {
    code_title: "Verifica SMS",
    phone_number: "Numero di telefono",
    verification_code: "Inserisci il codice di verifica dall’SMS",
    captcha_code: "Codice",
    send_code: "Invia codice",
    login: "Accedi",
    agree: "Cliccando Accedi, accetti ",
    readme: "il Contratto utente",
    msg_fail_login: "Accesso non riuscito",
    msg_success_login: "Accesso riuscito",
    msg_fail_user: "Errore nel recupero delle informazioni utente. Vuoi riprovare?",
    sign_in_with: "Accedi con",
    no_sms: "Non hai ricevuto l’SMS",
    retry: "Invia di nuovo"
  },
  confirm: {
    deletecard: "Elimina carta",
    addcard: "Inserisci i dati della carta",
    title: "Conferma pagamento",
    paynow: "Pagamento immediato",
    SMSConfirm:
      "Per favore paga in base al messaggio ricevuto sul telefono e fai clic sul pulsante di conferma per continuare.",
    pay_label: "Importo",
    auth_label: "Pre‑autorizzazione",
    price_tips:
      "Il saldo può essere prelevato su richiesta. Potrebbero essere necessari 1‑5 giorni lavorativi per comparire nel tuo account di pagamento.",
    auth_tips:
      "È obbligatoria una pre‑autorizzazione di {0}{1}. L’importo effettivo del noleggio verrà addebitato al momento della restituzione del power bank.",
    pay_type: "Seleziona il metodo di pagamento preferito",
    submit: "Conferma pagamento",
    msg_loading: "Caricamento...",
    msg_fail_title: "Avviso",
    msg_fail_payment: "Impossibile avviare il pagamento del deposito",
    msg_fail_order: "Impossibile creare un ordine di noleggio",
    msg_fail_support: "Sistema non supportato",
    msg_fail_confirm: "Conferma",
    msg_fail_retry: "Riprova",
    msg_fail_cancel: "Annulla"
  },
  mine: {
    title: "Profilo utente",
    wallet: "Il mio portafoglio",
    balance: "Il mio saldo",
    deposit: "Deposito",
    wallet_in: "Ricarica",
    wallet_out: "Preleva",
    wallet_log: "Registro portafoglio",
    rental_history: "Storico noleggi",
    payment_title: "Metodi di pagamento",
    download_app: "Scarica l’app",
    settings: "Impostazioni",
    help: "Aiuto",
    logout: "Esci",
    login_tips: "Effettua l’accesso",
    msg_fail_title: "Errore",
    msg_fail_update: "Modifica non riuscita. Riprova",
    msg_loading: "Caricamento...",
    msg_fail_user: "Errore nel recupero delle informazioni utente. Vuoi riprovare?",
    edit_profile: "Modifica profilo",
    join_us: "UNISCITI A NOI",
    join_us_details: "Ottieni una stazione Cargamos nella tua sede"
  },
  msg: {
    appoffline: "L’app non è ancora stata avviata, attendi",
    deletecard: "Sei sicuro di voler eliminare questa carta?",
    no_phone: "Il numero di telefono è obbligatorio",
    loading: "Caricamento...",
    title: "Suggerimento",
    success: "Operazione riuscita",
    error: "Errore sconosciuto. Riprova più tardi",
    roleerror: "Permessi insufficienti. Consulta l’amministratore.",
    neterror: "Connessione di rete non riuscita. Riprova più tardi",
    confirm: "Conferma",
    retry: "Riprova",
    cancel: "Annulla",
    title_fail: "Avviso",
    vieworder: "Vedi ordine",
    success_payment: "Pagamento completato",
    success_buy: "Acquisto completato",
    fail_payment: "Pagamento non riuscito",
    keyword: "Parola chiave",
    ispayorder: "Conferma che il pagamento sia stato effettuato",
    unpay: "Non pagato",
    yespay: "Pagato",
    notopen: "Non ancora aperto"
  },
  result: {
    tips:
      "Per visualizzare ordini e altre stazioni, scarica l’applicazione.",
    download: "Scarica l’app",
    title: "Noleggio confermato",
    gotit: "Ho capito",
    price_plan: "Tariffa",
    msg_success: "Noleggio riuscito",
    msg_tips_loading: "Il power bank sta uscendo, attendi...",
    msg_result_loading: "Si sta confermando l’esito del pagamento...",
    msg_fail_confirm: "Conferma",
    btn_usage: "Nota d’uso",
    btn_return: "Nota di restituzione",
    deposit: "Deposito",
    msg_fail_content: "Richiesta non riuscita. Riprova.",
    price_label: "all’ora",
    price_info:
      "I primi {mianfei} minuti sono gratis, la tariffa massima giornaliera è {ccurrency}{fengding}. Il deposito sarà detratto automaticamente quando il noleggio raggiunge {ccurrency}{yajin}",
    tips_1: "Ritira il power bank n.{number} come mostrato nell’immagine",
    tips_2:
      "Sistema i cavi e inserisci il power bank nello slot con il lato contrassegnato da [frecce verso il basso]",
    msg_note_usage:
      "Il power bank è dotato di 3 tipi di cavi, scegli quello adatto al tuo dispositivo.",
    msg_note_return:
      "Sistema i cavi e inserisci il power bank nello slot con il lato contrassegnato da [frecce verso il basso]",
    return_info:
      "Alla restituzione, assicurati che i cavi siano ordinati e inserisci il lato con i contatti metallici in uno slot disponibile fino in fondo.",
    download_tips:
      "Per noleggiare il nostro powerbank, puoi scegliere una delle seguenti opzioni"
  },
  result_msg: {
    loading: "Caricamento...",
    refresh: "Aggiorna"
  },
  order: {
    title: "Storico noleggi",
    in_use: "In uso",
    ended: "Terminato",
    msg_error: "Richiesta non riuscita",
    order_number: "N.",
    order_details: "Dettagli ordine",
    order_zj_shop: "Sede di noleggio",
    order_zj_time: "Ora di noleggio",
    order_gh_shop: "Sede di restituzione",
    order_gh_time: "Ora di restituzione",
    order_use_time: "Tempo di utilizzo",
    order_amount: "Importo totale",
    not_on_rent: "Non a noleggio",
    renting: "A noleggio",
    undone: "Non concluso",
    returned: "Restituito",
    questions: "Domande",
    timeout_to_return: "Tempo di restituzione scaduto",
    suspended_for_billing: "Sospeso per fatturazione"
  },
  order_item: {
    order_number: "N.",
    venue_rented: "Luogo di ritiro",
    time_rented: "Ora di ritiro",
    venue_returned: "Luogo di restituzione",
    time_returned: "Ora di restituzione",
    charge_standard: "Tariffa",
    charge_standard_info:
      "{pJifei} {pCurrency} all’ora (primi {pMian} min gratis)",
    rent_occurred: "Noleggio effettuato",
    returned: "Restituito",
    unreturned: "Non restituito",
    type_0: "Non completato",
    type_1: "A noleggio",
    type_2: "Annullato",
    type_3: "Restituito",
    type_4: "Si è verificato un errore",
    type_5: "Straordinario",
    min: "min",
    payment: "Pagamento"
  },
  setting: {
    title: "Impostazioni",
    lang: "Lingua"
  },
  help: {
    title: "FAQ",
    rentals: "Noleggi",
    venues: "Sedi",
    payments: "Pagamenti"
  },
  wallet_in: {
    title: "Ricarica saldo",
    price_label: "Importo ricarica",
    price_placeholder: "Inserisci l’importo di ricarica",
    balance: "Saldo attuale",
    price_auto: "Scegli importo di pagamento",
    price_tips:
      "Il saldo può essere prelevato su richiesta. Potrebbero essere necessari 1‑5 giorni lavorativi per comparire nel tuo account di pagamento.",
    submit: "Invia",
    loading: "Caricamento...",
    paying: "Reindirizzamento alla pagina di pagamento...",
    msg_title: "Suggerimenti",
    msg_fail_order: "Impossibile creare l’ordine di ricarica",
    msg_fail_payment: "Impossibile avviare il pagamento della ricarica",
    msg_fail_retry: "Riprova"
  },
  wallet_out: {
    title: "Prelievo",
    price_label: "Importo prelievo",
    price_placeholder: "Inserisci l’importo di prelievo",
    balance: "Saldo attuale",
    balance_all: "Preleva tutto",
    deposit: "Deposito",
    deposit_tips:
      "C’è un ordine di noleggio in sospeso. Il deposito di Ksh{pyajin} non è rimborsabile",
    submit: "Invia",
    apply: "Richiedi",
    confirm: "Conferma",
    loading: "Caricamento...",
    msg_fail_price: "L’importo del prelievo non è corretto",
    msg_fail_balance: "L’importo del prelievo non può superare il saldo attuale",
    msg_fail_submit: "Compila tutti i campi obbligatori",
    msg_title: "Errore",
    msg_success_content: "Rimborso riuscito",
    confirmtitle: "Suggerimenti",
    confirmcontent:
      "Il portafoglio attuale non supporta il prelievo di contanti. Lascia le informazioni di contatto per l’elaborazione manuale del rimborso",
    payee_name: "Nome beneficiario",
    payee_bankcard: "Numero carta bancaria",
    payee_phone: "Telefono",
    cancelText: "Annulla",
    confirmText: "Richiedi di nuovo"
  },
  map: {
    在线: "Aperto",
    离线: "Chiuso",
    title: "Stazione vicina",
    result_msg: "Nessuna stazione trovata nelle vicinanze",
    msg_title: "errore",
    no_support: "Spiacenti! Il tuo browser non supporta i servizi di localizzazione",
    my_position: "La mia posizione",
    distance: "Distanza:",
    shop_time: "Orari",
    free: "Disponibile per il noleggio",
    return: "Slot vuoti disponibili",
    shop_title: "Dettagli della sede",
    address: "Indirizzo",
    go_here: "Vai qui",
    nav_help: "Aiuto",
    nav_search: "Cerca"
  },
  scanQr: {
    NotAllowedError: "Devi concedere l’accesso alla fotocamera",
    NotFoundError: "Non c’è una fotocamera su questo dispositivo",
    NotSupportedError: "È richiesto un contesto sicuro (HTTPS, localhost)",
    NotReadableError: "La fotocamera è in uso",
    OverconstrainedError: "La configurazione della fotocamera non è adeguata",
    StreamApiNotSupportedError:
      "Questo browser non supporta l’API di streaming"
  },
  payment: {
    payment_title: "Metodi di pagamento",
    pay_type: "Aggiungi i dati della tua carta",
    add_payment_card: "Aggiungi carta di pagamento",
    add_payment: "aggiungi pagamento"
  },
  shop: {
    title: "Stazione vicina",
    search_station: "Cerca una stazione",
    search_station_tips: "Inserisci il nome della stazione",
    shop_power_banks: "Power bank",
    shop_empty_slots: "Slot vuoti",
    shop_address: "Indirizzo",
    shop_business_hours: "Orari di apertura",
    shop_directions_station: "Indicazioni per la stazione",
    shop_scan_qrcode: "Scansiona QR"
  },
  paymethod: {
    payamount: "Importo da pagare",
    choosepaymethod: "Scegli opzioni di pagamento",
    addcard: "Aggiungi nuova carta",
    confrimpay: "Conferma pagamento",
    借记卡: "Carta di debito",
    银行卡列表: "Elenco carte bancarie"
  },
  orderDetail: {
    price1: "{pJifei} {pCurrencyName} per {pJifeiDanwei} {priceUnit}",
    price2: "Fino a {pFengding} {pCurrencyName} per 24 ore",
    price3: "Penale di mancata restituzione {overtimeAmount} {pCurrencyName}",
    venuerented: "Sede di noleggio",
    venuereturned: "Sede di restituzione",
    timerented: "Ora di noleggio",
    timereturned: "Ora di restituzione",
    powerbankid: "ID Power Bank",
    getreceipt: "OTTIENI RICEVUTA",
    buypowerbank: "Acquista questo power bank",
    usetime: "Tempo di utilizzo",
    estimatedamount: "Importo stimato",
    feerule: "Regola tariffaria",
    payment: "Pagamento",
    orderNo: "N. ordine",
    trafficDetails: "Vedi dettagli traffico pacchetto",
    Renewals: "Rinnovi",
    FeeSchedule: "Tabella tariffe",
    HowToUse: "Come usare",
    LeaseMerchant: "Locatore",
    startTime: "Ora di inizio",
    ReturningMerchants: "Sedi di restituzione",
    EndTime: "Ora di fine",
    Deposit: "Deposito",
    fee1: "Deposito attrezzatura {overtimeAmount} {pCurrencyName}",
    fee2:
      "Restituito entro {overtime} giorni dopo la scadenza del noleggio, meno {pFengding} {pCurrencyName} per 24 ore.",
    fee3:
      "Se l’attrezzatura viene restituita entro {overtime} giorni dalla scadenza del periodo di noleggio, verrà detratto {overtimeAmount} {pCurrencyName}.",
    fee4:
      "Il deposito verrà detratto automaticamente se l’attrezzatura non viene restituita oltre 15 giorni dalla scadenza dei giorni di noleggio.",
    rentagain: "Noleggia di nuovo",
    onrental: "In noleggio",
    revoked: "Revocato",
    returned: "Restituito",
    issue: "Problema",
    overtimereturn: "Scaduto"
  },
  selectpackage: {
    powerbank: "Power bank",
    powerstation: "Stazione",
    wifibox: "Box Wi‑Fi",
    choosepackage: "Scegli un pacchetto traffico",
    minute: "minuto",
    首次免费: "Gratuito per i primi ",
    最大每日收费: "Tariffa giornaliera massima ",
    devicedeposit: "Deposito dispositivo",
    return_will_back: "Restituisci il deposito dopo il ritorno del dispositivo",
    lengthofuse: "Durata d’uso",
    amountcharged: "Importo accumulato",
    release_powerbank: "Rilascia il tuo power bank",
    see_pricing: "Vedi prezzi",
    deposit: "deposito",
    agreen: "Continuando, accetti la nostra ",
    privacy_policy: "Informativa sulla privacy",
    and: " e ",
    terms_and_conditions: "Termini e condizioni.",
    per: "per"
  },
  rentcost: {
    rentcosttitle: "Quanto costa il noleggio?",
    price1: "{currency} {jifei} per {jifeiDanwei} {priceUnit}",
    price2: "{currency} {fengding} al giorno",
    tip1:
      "Se non restituisci il power bank entro {overtime} giorni, ti verrà addebitato {overtimeAmount} {currency} e non dovrai restituirlo.",
    tip2: "Un giorno di noleggio corrisponde a 24 ore dal momento del ritiro del power bank.",
    tip3:
      "Addebiteremo {yajin} {currency} come deposito cauzionale, che verrà restituito una volta restituita la batteria alla stazione.",
    tip4: "Alcune sedi potrebbero offrire ore gratuite o sconti. Buon divertimento!",
    Days: "Giorni",
    Hours: "Ore",
    Minutes: "Minuti",
    free: "{mianfei} minuti gratis",
    willcharged: "Ti verranno addebitati {currency} {money}"
  }
};
